import React, { Fragment } from 'react'
import PaginatedConnectionTable from 'components/PaginatedConnectionTable'
import graphqlQuery from 'graphs/queries/UsersPaginated.graphql'
import withConnectionQuery from 'components/withConnectionQuery'
import fields from 'fields/users'
import { Mutation } from 'react-apollo'
import toggleUserCompany from 'graphs/mutations/toggleUserCompany.graphql'
import UserFragment from 'graphs/fragments/UserFields.graphql'
import SwitchWithMutation from 'components/SwitchWithMutation'

const RouteUsers = ({ variables, ...props }) => (
  <Mutation mutation={toggleUserCompany}>
    {mutate => (
      <Fragment>
        <h3>Users</h3>
        <PaginatedConnectionTable
          {...props}
          fields={[
            {
              props: {
                dataKey: 'manage',
                key: 'manage',
                render: data => (
                  <SwitchWithMutation
                    initialValue={data.has_company}
                    id={`row-${data.id}`}
                    mutate={mutate}
                    buildMutationOptions={value => ({
                      variables: {
                        input: {
                          user_id: data.id,
                          company_id: variables.company_id,
                          value
                        },
                        company_id: variables.company_id
                      },
                      update: (store, { data: { toggle_user_company } }) => {
                        store.writeFragment({
                          id: data.id,
                          fragment: UserFragment,
                          variables,
                          data: toggle_user_company
                        })
                      }
                    })}
                    {...props}
                  />
                )
              }
            },
            ...fields
          ]}
          manage
          onRowClick={() => {}}
        />
      </Fragment>
    )}
  </Mutation>
)

export default withConnectionQuery({
  graphqlQuery,
  paginated: true,
  namespace: 'users'
})(RouteUsers)



// WEBPACK FOOTER //
// ./src/routes/admin/companies/users/manage.js